module.exports = __webpack_public_path__ + "static/media/lds-logo_ms.a1e820f0.svg";